export const CONTENT_TYPES = {
  pdf: 'application/pdf',
  xslx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};



// WEBPACK FOOTER //
// ./src/constants/content-types.js